import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Button, Alert, Container, Card, Row, Col, Image  } from 'react-bootstrap';
import config from '../config';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { confirmation, terminationAlert, alertPlanMappingWarning, cobraSubmittedAlert, saveAlert } from '../alerts/Alerts';

import useFetchCase from '../hooks/useFetchCase';
import DirectBillMedicalPlans from '../components/directBill/DirectBillMedicalPlans';
import CompanyLayout from '../layouts/CompanyLayout';
import DirectBillGeneralInformation from '../components/directBill/DirectBillGeneralInformation';
import DirectBillDentalPlans from '../components/directBill/DirectBillDentalPlans';
import DirectBillEAPPlans from '../components/directBill/DirectBillEAPPlans';
import DirectBillVisionPlans from '../components/directBill/DirectBillVisionPlans';
import DirectBillHRAPlans from '../components/directBill/DirectBillHRAPlans';
import DirectBillFSAPlans from '../components/directBill/DirectBillFSAPlans';
import DirectBillInsurancePlans from '../components/directBill/DirectBillInsurancePlans';
import DirectBillEnrollmentContacts from '../components/directBill/DirectBillEnrollmentContacts';
import DirectBillOpenEnrollment from '../components/directBill/DirectBillOpenEnrollment';
import DirectBillEmployeeCensus from '../components/directBill/DirectBillEmployeeCensus';
import ChangeContact from '../components/ChangeContact';
import Layout from '../layouts/Layout';
import ClarityLogo from '../assets/images/clarity-logo.png';
import SurveyMonkey from '../services/SurveyMonkey';

function DirectBill({ onError = () => {} }) {
  const { caseId } = useParams();
  const location = useLocation();
  //const renewalCase = location.state?.company;
  const navigate = useNavigate();
  const generalInfoRef = useRef();
  const medicalPlansRef = useRef();
  const dentalPlansRef = useRef();
  const visionPlansRef = useRef();
  const eapPlansRef = useRef();
  const hraPlansRef = useRef();
  const fsaPlansRef = useRef();
  const insurancePlansRef = useRef();
  const employeecensusRef = useRef();
  const openEnrollRef = useRef();

  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);

  const [username, setUsername] = useState(sessionStorage.getItem('username'));
  const [decodedToken, setDecodedToken] = useState(sessionStorage.getItem('decodedToken'));
  const [bearerToken, setBearerToken] = useState(sessionStorage.getItem('bearerToken'));

  const [plan, setPlans] = useState({
    cobraMedicalPlans: [],
    cobraDentalPlans: [],
    cobraVisionPlans: [],
    cobraEAPPlans: [],
    cobraHRAPlans: [],
    cobraFSAPlans: [],
    cobraInsurancePlans: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [renewalCase, setRenewalcase] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const medicalFetchUrl = `${config.API_URL}/cobraMedicalPlans/ByCaseId/${caseId}`;
  const dentalFetchUrl = `${config.API_URL}/cobraDentalPlans/ByCaseId/${caseId}`;
  const visionFetchUrl = `${config.API_URL}/cobraVisionPlans/ByCaseId/${caseId}`;
  const EAPFetchUrl = `${config.API_URL}/cobraEAPPlans/ByCaseId/${caseId}`;
  const HRAFetchUrl = `${config.API_URL}/cobraHRAPlans/ByCaseId/${caseId}`;
  const FSAFetchUrl = `${config.API_URL}/cobraFSAPlans/ByCaseId/${caseId}`;
  const insuranceFetchUrl = `${config.API_URL}/cobraInsurancePlans/ByCaseId/${caseId}`;
  
  useEffect(() => {
    const fetchcase = async () => {
      try {
        const response = await axios.get(`${config.API_URL}/RenewalCases/${caseId}`);
        setRenewalcase(response.data);
      } catch (error) {
        console.error('Error fetching cases:', error);
      }
    };
    fetchcase();
    //fetchPlans();
  }, []);


  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("showPopup") === "true") {
      setShowPopup(true);
    }
  }, [location]);
 
  const handleCloseModalOne = () => {
    setShowPopup(false);
  };
  
  
  
  


  const handleError = (error) => {
    setSubmitError('There was an error updating the form. Please try again.');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    setSubmitSuccess(false);
    setShowValidationMessage(false);
  
    
    try {
      
      //await fetchPlans();  
  
      const refs = [
        generalInfoRef,
        medicalPlansRef,
        dentalPlansRef,
        visionPlansRef,
        eapPlansRef,
        hraPlansRef,
        fsaPlansRef,
        insurancePlansRef,
        employeecensusRef,
        openEnrollRef,
      ];
  
      let isValid = true;
  
      for (let ref of refs) {
        if (ref.current && typeof ref.current.validateAll === 'function') {
          const valid = ref.current.validateAll();
          //alert(valid)
          if (!valid) {
            isValid = false;
          }
        }

        
      }

     
      
      if (isValid) {
       
        
        
        await showNotice(refs);  
        setSubmitSuccess(true);
      } else {
        setSubmitError('Please correct the highlighted errors before submitting.');
        setShowValidationMessage(true);
      }
      
    } catch (error) {
      console.error('Error saving plan changes or fetching plans:', error);
      setSubmitError('There was an error while saving changes. Please try again.');
    }
  };
  


  

const showNotice = async (refs) => {

  const plansData = {
    cobraMedicalPlans: [],
cobraDentalPlans: [],
cobraVisionPlans: [],
cobraEAPPlans: [],
cobraHRAPlans: [],
cobraFSAPlans: [],
cobraInsurancePlans: []
  };
  
  // Define a mapping of plan names to `plansData` keys
  const planNameToKeyMap = {
    'Medical': 'cobraMedicalPlans',
    'Dental': 'cobraDentalPlans',
    'Vision': 'cobraVisionPlans',
    'EAP': 'cobraEAPPlans',
    'HRA': 'cobraHRAPlans',
    'FSA': 'cobraFSAPlans',
    'Insurance': 'cobraInsurancePlans'
  };


  for (let ref of refs) {
    if (ref.current && typeof ref.current.getPlans === 'function') {
      const cobarPlan = ref.current.getPlans();
      const planName = ref.current.planName;
      
      // Get the corresponding key from the mapping
      const key = planNameToKeyMap[planName];
      
      if (key) {
        
        const flattenedPlan = cobarPlan.flat(); 
        plansData[key] = [...plansData[key], ...flattenedPlan];
      }
      
      
    }
  }
  
 
  const isTerminatingAndOtherPlansExist = (arr) =>
    arr && arr.length > 1 && arr.some(item => item.isTerminating !== "true");

  const getTerminatingPlans = (plansArray) =>
    plansArray && isTerminatingAndOtherPlansExist(plansArray)
      ? plansArray.filter(plan => plan.isTerminating === "true")
      : [];

  
  const getCorrespondingPlans = (plansArray, terminatingPlan) => {
    return plansArray.filter(plan => plan.isTerminating !== 'true');
  };

  
  const terminatingPlans = [
    ...getTerminatingPlans(plansData?.cobraMedicalPlans || []),
    ...getTerminatingPlans(plansData?.cobraDentalPlans || []),
    ...getTerminatingPlans(plansData?.cobraVisionPlans || []),
    ...getTerminatingPlans(plansData?.cobraHRAPlans || []),
    ...getTerminatingPlans(plansData?.cobraFSAPlans || []),
    ...getTerminatingPlans(plansData?.cobraEAPPlans || []),
    ...getTerminatingPlans(plansData?.cobraInsurancePlans || []),
  ];

  
  if (terminatingPlans.length > 0) {
    const terminationAlertContent = `
    <p>You indicated that some plans are terminating. Choose the Plan to which pending and active participants should be moved if they do not make an election.</p>
    <div class="container">
      <table class="table">
        <thead>
          <tr>
            <th>Terminating Plan</th>
            <th>Plan Mapping</th>
          </tr>
        </thead>
        <tbody>
          ${terminatingPlans.map(terminatingPlan => {
            let correspondingPlans = [];

            let planType = "";

            if (plansData?.cobraMedicalPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraMedicalPlans, terminatingPlan);
              planType = "Medical";
            } else if (plansData?.cobraDentalPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraDentalPlans, terminatingPlan);
              planType = "Dental";
            } else if (plansData?.cobraVisionPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraVisionPlans, terminatingPlan);
              planType = "Vision";
            } else if (plansData?.cobraHRAPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraHRAPlans, terminatingPlan);
              planType = "HRA";
            } else if (plansData?.cobraFSAPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraFSAPlans, terminatingPlan);
              planType = "FSA";
            } else if (plansData?.cobraEAPPlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraEAPPlans, terminatingPlan);
              planType = "EAP";
            } else if (plansData?.cobraInsurancePlans?.includes(terminatingPlan)) {
              correspondingPlans = getCorrespondingPlans(plansData.cobraInsurancePlans, terminatingPlan);
              planType = "Insurance";
            }

            return `
              <tr>
                <td data-label="terminatingplan">${terminatingPlan.planName}</td>
                <td data-label="planmapping">
                  <select class="COBRADataSource selectpickers form-control" onchange="handlePlanMappingChange('${planType}','${terminatingPlan.planId}', this.value)">
    <option value="DROP_PLAN">Drop Plan</option>
    ${correspondingPlans.map(nonTerminatingPlan => `
        <option value="${nonTerminatingPlan.planId}|${nonTerminatingPlan.planName}">
            ${nonTerminatingPlan.planName}
        </option>
    `).join('')}
</select>
                </td>
              </tr>
            `;
          }).join('')}
        </tbody>
      </table>
    </div>`;

    const terminationAlert = (content) => {
      
      var dialogContainer = document.getElementById('dialogContainer');
      if (!dialogContainer) {
          dialogContainer = document.createElement('div');
          dialogContainer.id = 'dialogContainer';
          document.body.appendChild(dialogContainer);
      }

      dialogContainer.innerHTML = '<div id="dialogoverlay"></div><div id="dialogbox" class="slit-in-vertical"><div><div id="dialogboxhead"></div><div id="dialogboxbody"></div><div id="dialogboxfoot"></div></div></div>';

      var dialogoverlay = document.getElementById('dialogoverlay');
      var dialogbox = document.getElementById('dialogbox');

      var winH = window.innerHeight;
      dialogoverlay.style.height = winH + "px";

      dialogbox.style.top = "100px";

      dialogoverlay.style.display = "block";
      dialogbox.style.display = "block";

      var dialogboxhead = document.getElementById('dialogboxhead');
      dialogboxhead.style.display = 'block';
      dialogboxhead.innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> Plan Mapping';

      document.getElementById('dialogboxbody').innerHTML = content;

      const yesButton = document.createElement('button');
      yesButton.className = "pure-material-button-contained-yes active me-2";
      yesButton.textContent = "Save";
      yesButton.onclick = async () => {
        try {
          const response = await axios.get(`${config.API_URL}/CaseFiles/${caseId}`);
          const files = response.data || [];
          const missingSBCPlans = [];
      
          terminatingPlans.forEach(terminatingPlan => {
            // Gather corresponding plans for each type
            let correspondingPlans = getCorrespondingPlans(plansData.cobraMedicalPlans || [], terminatingPlan);
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraDentalPlans || [], terminatingPlan));
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraVisionPlans || [], terminatingPlan));
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraHRAPlans || [], terminatingPlan));
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraFSAPlans || [], terminatingPlan));
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraEAPPlans || [], terminatingPlan));
            correspondingPlans = correspondingPlans.concat(getCorrespondingPlans(plansData.cobraInsurancePlans || [], terminatingPlan));
      
           
            correspondingPlans.forEach(nonTerminatingPlan => {
              const foundFiles = files.filter(file => {
                
                return file.fileCategory === 'Summary of Benefits and Coverage (SBC) Documents' && file.meta === nonTerminatingPlan.planId;
              });
      
              // If no SBC files found for the corresponding plan, add to missing list
              if (foundFiles.length === 0) {
                missingSBCPlans.push(nonTerminatingPlan.planName); 
                
              }
            });
          });
      
          if (missingSBCPlans.length > 0) {
            
            confirmation(
              `NOTICE: You have not uploaded all of your SBC document(s). Once you submit your COBRA renewal, you will not have the option to upload the SBC document(s) here. You can provide SBC documents after renewal directly in the COBRA platform. Just click the 'Manage My COBRA' tile on the home page of the Clarity Portal.`,
              "Confirmation",
              async () => {
                try {

                  await axios.post(`${config.API_URL}/RenewalPortal/DirectBillFormSubmission/${caseId}`);
                  const patchDocument = [
                    { op: 'replace', path: '/cobraSubmissionStatus', value: 'Submitted' },
                    { op: "replace", path: "/submittedBy", value: username },
                    { op: "replace", path: "/submittedAt", value: new Date().toISOString() },
                    { op: 'replace', path: '/summaryURL', value: `${config.WEB_URL}/DirectBillSummary/${caseId}` }
                  ];
                  const url = `${config.API_URL}/RenewalCases/${caseId}`;
                  await axios.patch(url, patchDocument);
                  cobraSubmittedAlert(caseId, navigate);
                } catch (error) {
                  console.error('Error submitting renewal form:', error);
                  onError(error);
                }
              }
            );
          } else {
            
            await axios.post(`${config.API_URL}/RenewalPortal/DirectBillFormSubmission/${caseId}`);
            const patchDocument = [
              { op: 'replace', path: '/cobraSubmissionStatus', value: 'Submitted' },
              { op: "replace", path: "/submittedBy", value: username },
              { op: "replace", path: "/submittedAt", value: new Date().toISOString() },
              { op: 'replace', path: '/summaryURL', value: `${config.WEB_URL}/DirectBillSummary/${caseId}` }
            ];
            const url = `${config.API_URL}/RenewalCases/${caseId}`;
            await axios.patch(url, patchDocument);
            cobraSubmittedAlert(caseId, navigate);
          }
        } catch (error) {
          console.error('Error fetching files:', error);
        }
      };
            

      const noButton = document.createElement('button');
      noButton.className = "pure-material-button-contained active";
      noButton.textContent = "Cancel";
      noButton.onclick = () => {
        alertPlanMappingWarning('This plan mapping is required to complete your COBRA renewal. Canceling will leave your COBRA renewal incomplete. Do you still wish to Cancel?',
           'Warning', content);
      };

      document.getElementById('dialogboxfoot').innerHTML = '';
      document.getElementById('dialogboxfoot').appendChild(yesButton);
      document.getElementById('dialogboxfoot').appendChild(noButton);
    };

    const alertPlanMappingWarning = (message, title, terminationAlertContent) => {
      var dialogContainer = document.getElementById('dialogContainer');
      if (!dialogContainer) {
          dialogContainer = document.createElement('div');
          dialogContainer.id = 'dialogContainer';
          document.body.appendChild(dialogContainer);
      }
    
      dialogContainer.innerHTML = '<div id="dialogoverlay"></div><div id="dialogbox" class="slit-in-vertical"><div><div id="dialogboxhead"></div><div id="dialogboxbody"></div><div id="dialogboxfoot"></div></div></div>';
    
      var dialogoverlay = document.getElementById('dialogoverlay');
      var dialogbox = document.getElementById('dialogbox');
    
      var winH = window.innerHeight;
      dialogoverlay.style.height = winH + "px";
    
      dialogbox.style.top = "100px";
    
      dialogoverlay.style.display = "block";
      dialogbox.style.display = "block";
    
      var dialogboxhead = document.getElementById('dialogboxhead');
      if (typeof title === 'undefined') {
          dialogboxhead.style.display = 'none';
      } else {
          dialogboxhead.style.display = 'block';
          dialogboxhead.style.color = '#FF6347';
          dialogboxhead.innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> ' + title;
      }
    
      document.getElementById('dialogboxbody').innerHTML = message;
    
      var yesButton = document.createElement('button');
      yesButton.className = "pure-material-button-contained-yes active me-2";
      yesButton.textContent = "Yes";
      yesButton.onclick = (() => dialogContainer.remove());
    
      var noButton = document.createElement('button');
      noButton.className = "pure-material-button-contained active";
      noButton.textContent = "No";
      noButton.onclick = () => {
          terminationAlert(
              terminationAlertContent
          );
      };
    
      document.getElementById('dialogboxfoot').innerHTML = '';
      document.getElementById('dialogboxfoot').appendChild(yesButton);
      document.getElementById('dialogboxfoot').appendChild(noButton);
    };

    terminationAlert(terminationAlertContent);
  } else {

    const allPlans = [
      ...(plansData?.cobraMedicalPlans || []),
      ...(plansData?.cobraDentalPlans || []),
      ...(plansData?.cobraVisionPlans || []),
      ...(plansData?.cobraHRAPlans || []),
      ...(plansData?.cobraFSAPlans || []),
      ...(plansData?.cobraEAPPlans || []),
      ...(plansData?.cobraInsurancePlans || []),
    ];



    try {
          const response = await axios.get(`${config.API_URL}/CaseFiles/${caseId}`);
          const files = response.data || [];
          const missingSBCPlans = [];
      
          allPlans.forEach(availablePlan => {
            

            const availablePlans = Array.isArray(availablePlan) ? availablePlan : [availablePlan].filter(Boolean);
            availablePlans.forEach(plan => {
              const foundFiles = files.filter(file => {
                
                return file.fileCategory === 'Summary of Benefits and Coverage (SBC) Documents' && file.meta === plan.planId;
              });
      
              // If no SBC files found for the corresponding plan, add to missing list
              if (foundFiles.length === 0) {
                missingSBCPlans.push(plan.planName); 
                
              }
            });
          });
      
          if (missingSBCPlans.length > 0) {
            
            confirmation(
              `NOTICE: You have not uploaded all of your SBC document(s). Once you submit your COBRA renewal, you will not have the option to upload the SBC document(s) here. You can provide SBC documents after renewal directly in the COBRA platform. Just click the 'Manage My COBRA' tile on the home page of the Clarity Portal.`,
              "Confirmation",
              async () => {
                try {

                  await axios.post(`${config.API_URL}/RenewalPortal/DirectBillFormSubmission/${caseId}`);
                  const patchDocument = [
                    { op: 'replace', path: '/cobraSubmissionStatus', value: 'Submitted' },
                    { op: "replace", path: "/submittedBy", value: username },
                    { op: "replace", path: "/submittedAt", value: new Date().toISOString() },
                    { op: 'replace', path: '/summaryURL', value: `${config.WEB_URL}/DirectBillSummary/${caseId}` }
                  ];
                  const url = `${config.API_URL}/RenewalCases/${caseId}`;
                  await axios.patch(url, patchDocument);
                  cobraSubmittedAlert(caseId, navigate);
                } catch (error) {
                  console.error('Error submitting renewal form:', error);
                  onError(error);
                }
              }
            );
          } else {
            
            await axios.post(`${config.API_URL}/RenewalPortal/DirectBillFormSubmission/${caseId}`);
            const patchDocument = [
              { op: 'replace', path: '/cobraSubmissionStatus', value: 'Submitted' },
              { op: "replace", path: "/submittedBy", value: username },
              { op: "replace", path: "/submittedAt", value: new Date().toISOString() },
              { op: 'replace', path: '/summaryURL', value: `${config.WEB_URL}/DirectBillSummary/${caseId}` }
            ];
            const url = `${config.API_URL}/RenewalCases/${caseId}`;
            await axios.patch(url, patchDocument);
            cobraSubmittedAlert(caseId, navigate);
          }
        } catch (error) {
          console.error('Error fetching files:', error);
        }
  }

  const handlePlanMappingChange = async (planType, terminatingPlanId, selectedValue) => {
    const [nonTerminatingPlanId, nonTerminatingPlanName] = selectedValue.split('|');
    const patchDocument = [
      { op: 'replace', path: '/mappedPlanId', value: nonTerminatingPlanId },
      { op: 'replace', path: '/mappedPlanName', value: nonTerminatingPlanName },
    ];
    
    const url = `${config.API_URL}/cobra${planType}Plans/${terminatingPlanId}`;
    
    try {
      const response = await axios.patch(url, patchDocument);
      console.log('Plan mapping updated successfully:', response.data);
    } catch (error) {
      console.error('Error updating plan mapping:', error);
    }
  };
  window.handlePlanMappingChange = handlePlanMappingChange;  

};

const handleOpenModal = useCallback(() => {
  setIsModalOpen(true);
}, []);

const handleCloseModal = () => {
  setIsModalOpen(false);
};

const disabledStatuses = ["closed", "cancelled", "closed non-response", "complete", "form submission"];
  const isDisableForUsers = disabledStatuses.includes(renewalCase?.caseStatus?.toLowerCase());

if (!username) return (<Layout>
  <div className="confirmation-container mt-5">
    <Card className="confirmation-card shadow-lg p-3 mb-5 bg-white rounded">
      <div className="text-center mb-4">
        <Image src={ClarityLogo} alt="Company Logo" className="confirmation-logo" />
      </div>

      <Alert variant="danger" className="text-center">Please login from the portal</Alert>



    </Card>
  </div>
</Layout>);



  return (
    <div>
      <CompanyLayout caseId={caseId} renewalCase={renewalCase}>
        <div className="row fixedHeader">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start"></div>
              <div className="d-flex justify-content-center">
              <span id="page-title">
  You are currently renewing benefits for <strong>{renewalCase?.employerName || " "}</strong>.
</span>
              </div>
              <div className="d-flex justify-content-end">
                <span className="pt-1 me-2" id="autoSavedMessage"></span>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-1 d-flex justify-content-end">
          {showValidationMessage && ( 
              <span className="pt-1 me-2" id="validationMessage" style={{ color: 'rgb(255, 99, 71)' }}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i> Error: Please ensure all fields are complete.
              </span>
            )}
            <button
              type="button"
              className="btn btn-primary btn-sm mt-1 me-1 " onClick={() => handleOpenModal(renewalCase?.caseId)}
              //disabled={renewalCase?.cobraSubmissionStatus === 'Submitted'|| isDisableForUsers}
              disabled={isDisableForUsers}
            >
              INVITE COLLABORATORS
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm mt-1 me-1 save-company-profile" onClick={saveAlert}
              //disabled={renewalCase?.cobraSubmissionStatus === 'Submitted'|| isDisableForUsers}
              disabled={isDisableForUsers}
            >
              SAVE
            </button>

            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-success btn-sm mt-1 me-1"
              id="reviewButton" 
              //disabled={renewalCase?.cobraSubmissionStatus === 'Submitted'|| isDisableForUsers}
              disabled={isDisableForUsers}
            >
              SUBMIT COBRA
            </button>
          </div>

          <div className="col-lg-12 progress-position">
            <div className="progress mb-3">
              {/* <div
                className="progress-bar progress-bar-success"
                role="progressbar"
                style={{ width: '22%' }}
              >
                <span id="totalProgress">22%</span>
              </div> */}
              <div
                className="progress-bar progress-bar-warning"
                role="progressbar"
                style={{ width: '100%' }}
              >
                <span id="pendingProgress"></span>
              </div>
            </div>
          </div>
        </div>

        <div id="page-content-wrapper">
          <div className="container-fluid">
            <div className="row startingrow">
              
              <Col className="d-flex justify-content-between">
              <h5 className="cobra-section">COBRA</h5>
              {renewalCase?.cobraSubmissionStatus === 'Submitted' && (
                <span className="pt-1 me-2"  style={{ color: 'rgb(103, 156, 91)' }}>
                <strong>
                  Renewal form submitted {renewalCase?.submittedAt
    ? new Date(renewalCase.submittedAt).toLocaleDateString('en-US')
    : ''}
    </strong> 
                </span>

              )}

              
              </Col>
              <DirectBillGeneralInformation ref={generalInfoRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillMedicalPlans ref={medicalPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillDentalPlans ref={dentalPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillVisionPlans ref={visionPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillEAPPlans ref={eapPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillHRAPlans ref={hraPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillFSAPlans ref={fsaPlansRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillInsurancePlans ref={insurancePlansRef} renewalCase={renewalCase} caseId={caseId} isDisableForUsers={isDisableForUsers} onError={handleError} />
              <DirectBillEnrollmentContacts caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError}/>
              <DirectBillOpenEnrollment ref={openEnrollRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError}/>
              <DirectBillEmployeeCensus ref={employeecensusRef} caseId={caseId} renewalCase={renewalCase} isDisableForUsers={isDisableForUsers} onError={handleError}/>
            </div>
          </div>
          {isModalOpen && <ChangeContact caseId={caseId} onClose={handleCloseModal} action='invite' companyName={renewalCase?.employerName} caseType={renewalCase?.caseType} />}
          {showPopup && 
            <SurveyMonkey isOpen={true}
              onClose={handleCloseModalOne}
              userEmail={renewalCase?.renewalContactEmail}/>
          }
        </div>
      </CompanyLayout>
    </div>
  );
}

export default DirectBill;
